import { from } from '@apollo/client';
import { DeviceType } from '@landr/react-core';
import { errorLink } from './apolloErrorLink';
import { transportLink } from './apolloTransportLink';
import { schemaVersionLink } from './apolloSchemaVersionLink';
import { loggerLink } from './apolloLoggerLink';
import { contextLink } from './apolloContextLink';
import { retryLink } from './apolloRetryLink';

export const link = (deviceType: DeviceType) =>
    from([
        schemaVersionLink,
        contextLink(deviceType),
        loggerLink,
        errorLink,
        retryLink,
        transportLink,
    ]);
